export default __webpack_public_path__ + "static/media/KheshattaValley.e7a6d7d6.jpg";